import template from '@components/expertise/discovery/discovery.module.scss';
import { IDiscoveryCards, IDiscoveryEndSection } from '../../discovery.state';
import Image from 'next/image';
import style from './index.module.scss';

interface IDiscoveryEndSectionProps {
  section: IDiscoveryEndSection;
}

const DiscoveryEndSectionComponent = ({ section }: IDiscoveryEndSectionProps) => {
  return (
    <section className={`${template.section} ${template.section__block_light}`}>
      <div className={`${template.container}`}>
        <h2 className={template.endofdiscovery__title}>{section.title}</h2>
        <div className={template.endofdiscovery__items}>
          {section.cards.map((item: IDiscoveryCards, index: number) => {
            return (
              <div key={index} className={template.endofdiscovery__item}>
                <div className={template.endofdiscovery__item__icon}>
                  <Image src={item.iconSrc} width={item.width} height={item.height} alt={item.title} />
                </div>
                <div className={template.endofdiscovery__item__title}>{item.title}</div>
                <div className={template.endofdiscovery__item__text}>{item.text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DiscoveryEndSectionComponent;
